import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import system from './reducers/system';
import articles from './reducers/articles';

//tell redux to match the following properties to each reducer
const rootReducer = combineReducers({

    system,
    articles,
  
})
  
const store = createStore(rootReducer, applyMiddleware(thunk));;
export default store